import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import clsx from 'clsx';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import * as actions from 'containers/Leads/actions';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import LeadCustomizeModal from 'pages/BusinessSettings/Leads/components/BookingProcess';
import DefaultAssignmentModal from 'pages/BusinessSettings/Leads/components/DefaultAssignment';
import IncomingNotificationsModal from 'pages/BusinessSettings/Leads/components/IncomingNotifications';
import { LeadsDownloadModal } from './Leads.DownloadModal';
import { useAddNewLead } from './CreateLeadForm';
import './styles.scss';

/**
 * @description: ActionButton Component from leads index.
 * @param {*}
 * @return {*}
 */
export const LeadsActionButton = ({ statuses, isEmpty }) => {
  const userInfo = useSelector((state) => state.global.userInfo);
  const [showActionOptions, toggleActionDropdown] = useState(false);
  const [downloadIsOpen, setDownloadIsOpen] = useState(false);
  const [isPreparing, setIsPreparing] = useState(false);
  const [showBookingProcessModal, setBookingProcessModal] = useState(false);
  const [showDefaultAssignmentsModal, setDefaultAssignmentsModal] = useState(false);
  const [showIncomingNotificationsModal, setIncomingNotificationsModal] = useState(false);

  const [newLeadModal, setNewLeadModalOpen] = useAddNewLead();

  const { permissions, orgId } = userInfo;
  const dispatch = useDispatch();
  const { getLeadsFiltersInBackground } = bindActionCreators(actions, dispatch);

  useEffect(() => {
    if (!showBookingProcessModal) {
      getLeadsFiltersInBackground();
    }
  }, [showBookingProcessModal]);

  const show = () => {
    toggleActionDropdown(!showActionOptions);
  };

  const dismiss = () => {
    toggleActionDropdown(false);
  };

  const customize = () => {
    setBookingProcessModal(true);
    dismiss();
  };

  const settings = () => {
    window.location = `/app/pro/${orgId}/settings/leads`;
  };

  const defaultAssignments = () => {
    setDefaultAssignmentsModal(true);
    dismiss();
  };

  const incomingNotifications = () => {
    setIncomingNotificationsModal(true);
    dismiss();
  };

  const download = () => {
    setDownloadIsOpen(true);
    dismiss();
  };

  const renderActionMenu = () => {
    return (
      <>
        <button
          className={clsx(
            'action_buttons__button',
            'button--unstyled',
            'button--menu',
          )}
          onClick={() => {
            setNewLeadModalOpen(true);
            dismiss();
          }}
        >
          Add New Lead
        </button>
        {permissions && permissions['settings.lead.edit'] && permissions['settings.lead.view'] && (
          <>
            <button
              className={clsx(
                'action_buttons__button',
                'button--unstyled',
                'button--menu',
                'border-top',
              )}
              onClick={defaultAssignments}
            >
              Manage Lead Assignments
            </button>
            <button
              className={clsx(
                'action_buttons__button',
                'button--unstyled',
                'button--menu',
              )}
              onClick={incomingNotifications}
            >
              Manage Lead Notifications
            </button>
            <button
              className={clsx(
                'action_buttons__button',
                'button--unstyled',
                'button--menu',
              )}
              onClick={customize}
            >
              Customize Booking Process
            </button>
            <button
              className={clsx(
                'action_buttons__button',
                'button--unstyled',
                'button--menu',
                'border-top',
              )}
              onClick={settings}
            >
              Manage All Lead Settings
            </button>
          </>
        )}
        {permissions && permissions['downloads.leads.edit'] && permissions['downloads.leads.view'] && !isEmpty && (
          <button
            className={clsx(
              'action_buttons__button',
              'button--unstyled',
              'button--menu',
              'download-link',
              'border-top',
              {
                loading: isPreparing,
              },
            )}
            onClick={download}
          >
            Download
          </button>
        )}
      </>
    );
  };

  const trigger = (
    <DropdownButton
      className="button button--md button--action"
    >
      <span className="visually-hidden--mobile">Actions</span>
      {showActionOptions ? <MdKeyboardArrowUp size={16} /> : <MdKeyboardArrowDown size={16} />}
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={showActionOptions}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
      >
        {renderActionMenu()}
      </APResponsiveDropdown>
      {showBookingProcessModal && (
        <LeadCustomizeModal
          open={showBookingProcessModal}
          onClose={() => setBookingProcessModal(false)}
        />
      )}
      {showDefaultAssignmentsModal && (
        <DefaultAssignmentModal
          open={showDefaultAssignmentsModal}
          onClose={() => setDefaultAssignmentsModal(false)}
        />
      )}
      {showIncomingNotificationsModal && (
        <IncomingNotificationsModal
          open={showIncomingNotificationsModal}
          onClose={() => setIncomingNotificationsModal(false)}
        />
      )}
      {statuses && (
        <LeadsDownloadModal
          statuses={statuses}
          downloadIsOpen={downloadIsOpen}
          dismiss={dismiss}
          setDownloadIsOpen={setDownloadIsOpen}
          setIsPreparing={setIsPreparing}
        />
      )}
      { newLeadModal }
    </>
  );
};
